import { FormDialog } from "../../components/FormDialog/FormDialog";

const CoreDocumentTypeDialog = ({ formId, readOnly, saveDocumentTypeData, documentTypeSchema, uiSchema, formData, handleFormChange }) => {

    return (
        <FormDialog formId={formId}
            formData={formData}
            schema={documentTypeSchema}
            uiSchema={uiSchema}
            handleFormChange={handleFormChange}
            readOnly={readOnly}
            saveFormData={saveDocumentTypeData}
        />
    );
}

export default CoreDocumentTypeDialog;
